import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import moment from 'moment'

import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from 'reactstrap'
import { FaEllipsisV, FaRegCopy, FaRegTrashAlt } from 'react-icons/fa'

import { projectInformationSelector } from '../../../../selectors'

import { SearchSelect, Input, NumberInput } from '../../../input'
import { CustomDatePicker } from '../../../datepicker'
import { FONTS } from '../../../../constants'

export const hardware_type = [
  { label: 'Hardware', value: 'HARDWARE' },
  { label: 'MA', value: 'HARDWARE_MA' },
]

export const credit_term = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '90', value: '90' },
]

const DropdownActions = ({ id, setShowCopyModal, copyRow, deleteRow }) => {
  return (
    <UncontrolledButtonDropdown>
      <Toggle>
        <FaEllipsisV />
      </Toggle>
      <DropdownMenu>
        <Item onClick={ () => copyRow(id) }>
          <FaRegCopy />
          Copy a row
        </Item>
        <Item onClick={ () => setShowCopyModal({ show: true, id }) }>
          <FaRegCopy />
          Copy as ...
        </Item>
        <Item onClick={ () => deleteRow(id) }>
          <FaRegTrashAlt />
          Delete
        </Item>
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  )
}

export const InputRow = (props) => {
  const [crType, setCrType] = useState([])
  const _crType = useSelector(projectInformationSelector.getCRType)

  const {
    id,
    changeRequest,
    isEdit,
    handleChangeInput,
    handleChangeSelect,
    handleChangeDate,
    setShowCopyModal,
    copyRow,
    deleteRow,
  } = props

  const canEditManDays = ['SERVICE', 'OTHER_SERVICE'].includes(changeRequest.cr_type)
  const canEditCost = changeRequest.cr_type !== 'SERVICE'
  const canEditDiliveryDateAndCreditTerm = changeRequest.cr_type !== 'SERVICE'

  useEffect(() => {
    setCrType(_crType.map(t => {
      return {
        label: t.charAt(0).toUpperCase() + t.replace('_', ' ').substring(1).toLowerCase().replace('ma', 'MA'),
        value: t,
      }
    }))
  }, [_crType])

  return (
    <Root>
      <SearchSelect
        name='cr_type'
        placeholder='Select Type'
        isDisabled={ !isEdit }
        onChange={ e => handleChangeSelect(e, id, 'cr_type') }
        value={ crType.find(t => t.value === changeRequest.cr_type) }
        options={ crType }
      />
      <Input
        name='qt_number'
        placeholder='Enter QT/PO'
        value={ changeRequest.qt_number }
        disabled={ !isEdit }
        onChange={ e => handleChangeInput(e, id) }
      />
      <Text>{ changeRequest.sub_project_code }</Text>
      {/* <Input
        name='name'
        placeholder='Enter Change Request'
        value={ changeRequest.name }
        disabled={ !isEdit }
        onChange={ e => handleChangeInput(e, id) }
      /> */}
      <Input
        name='description'
        placeholder='Enter Description'
        value={ changeRequest.description }
        disabled={ !isEdit }
        onChange={ e => handleChangeInput(e, id) }
      />
      <CustomDatePicker
        name='delivery_date'
        autoComplete='off'
        selected={ changeRequest.delivery_date ? moment(changeRequest.delivery_date) : null }
        dateFormat='DD/MM/YYYY'
        showYearDropdown
        showMonthDropdown
        disabled={ !isEdit || !canEditDiliveryDateAndCreditTerm }
        onChange={ e => handleChangeDate(e, id) }
      />
      <SearchSelect
        name='credit_term'
        placeholder='Select Credit Term'
        isDisabled={ !isEdit || !canEditDiliveryDateAndCreditTerm }
        onChange={ e => handleChangeSelect(e, id, 'credit_term') }
        value={ credit_term.find(t => t.value === changeRequest.credit_term) || null }
        options={ credit_term }
      />
      <NumberInput
        name='man_days'
        suffix='MDs'
        value={ changeRequest.man_days }
        allowEmptyFormatting={ true }
        thousandSeparator={ true }
        decimalScale={ 2 }
        fixedDecimalScale={ true }
        disabled={ !isEdit || !canEditManDays }
        onChange={ e => handleChangeInput(e, id) }
      />
      <NumberInput
        name='cost'
        prefix='฿'
        value={ changeRequest.cost }
        allowNegative={ true }
        allowEmptyFormatting={ true }
        thousandSeparator={ true }
        decimalScale={ 2 }
        fixedDecimalScale={ true }
        disabled={ !isEdit || !canEditCost }
        onChange={ e => handleChangeInput(e, id) }
      />
      <NumberInput
        name='price'
        prefix='฿'
        value={ changeRequest.price }
        allowNegative={ true }
        allowEmptyFormatting={ true }
        thousandSeparator={ true }
        decimalScale={ 2 }
        fixedDecimalScale={ true }
        disabled={ !isEdit }
        onChange={ e => handleChangeInput(e, id) }
      />
      { isEdit &&
        <DropdownActions
          id={ id }
          setShowCopyModal={ setShowCopyModal }
          copyRow={ copyRow }
          deleteRow={ deleteRow }
        />
      }
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 46px;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 2fr 1fr 1fr 1fr 1fr 1fr 25px;
  padding: 0 24px;
  background: #FFFFFF;
  margin-top: 1px;

  :nth-child(1) {
    margin: 0;
  }
`

const Toggle = styled(DropdownToggle)`
  width: 25px;
  background: transparent;
  border: none;
  outline: none;
  color: #333333;
  padding: 0;

  :hover, :active, :focus {
    border: none;
    box-shadow: none;
    border-radius: 4px !important;
    background: transparent !important;
    color: #333333 !important;
    outline: none !important;
  }
`

const Item = styled(DropdownItem)`
  display: flex;
  align-items: center;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};

  svg {
    margin-right: 12px;
  }
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-change-request/input-row.js